import { object } from 'prop-types';
import React from 'react';
import { BQLink } from '../bqlink';
import SvgIcon from '../svg-icon';
import './breadcrumb-basic.m.css';

const BreadcrumbBasic = props => {
  let sectionName = 'Exclusives'; // default section name
  let sectionSlug = 'exclusive'; // default section slug

  // Check if props.story.sections exists and is an array.
  if (Array.isArray(props?.story?.sections)) {
    // Loop through the sections array.
    for (let i = 0; i < props?.story?.sections?.length; i++) {
      // Get the current section from the array.
      const section = props?.story?.sections[i];

      // Check if the current section has a "display-name" key.
      if ('display-name' in section) {
        // If found, assign display-name to sectionName and slug to sectionSlug.
        sectionName = section['display-name'];
        sectionSlug = section.slug;
        // Break the loop ,once the section with a "display-name"is found
        break;
      }
    }
  }

  return (
    <div styleName="floating-breadcrumb" className="desktop-only">
      <div styleName="breadcrumb" className="container">
        <BQLink story={props.story} href={'/?src=story-page'}>
          <SvgIcon type="home-icon-dark" source="image" height="40" />
        </BQLink>
        <span styleName="dot"></span>
        <span>
          <BQLink href={`/${sectionSlug}?src=story-page`}>{sectionName}</BQLink>
        </span>
        <span styleName="dot"></span>
        <span styleName="breadcrumb-headline">{props.story.headline}</span>
      </div>
    </div>
  );
};

BreadcrumbBasic.propTypes = {
  story: object
};

export default BreadcrumbBasic;
